import { Button, DialogContent, DialogActions, DialogTitle, Dialog } from "@mui/material";

const ActionConfirmDialog = ({ open, actions = [], onClose, onConfirm }) => {
  const actionCount = actions.length;

  const getContentText = () => {
    if (actionCount === 0) return "Ingen åtgärd tillgänglig.";
    if (actionCount === 1) {
      const actionText = actions[0] === "SEND_ORDER_CONFIRMATION"
        ? "orderbekräftelse"
        : "leveransbesked";
      return `Du har ändrat leverantörsstatus. Vill du skicka ${actionText} nu?`;
    }
    return "Du har ändrat leverantörsstatus. Vilken av följande åtgärder vill du skicka?";
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Bekräfta automatisk åtgärd</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        {getContentText()}
      </DialogContent>
      <DialogActions>
        {actions.includes("SEND_ORDER_CONFIRMATION") && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => onConfirm("SEND_ORDER_CONFIRMATION")}
          >
            Skicka orderbekräftelse
          </Button>
        )}
        {actions.includes("SEND_DELIVERY_NOTICE") && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onConfirm("SEND_DELIVERY_NOTICE")}
          >
            Skicka leveransbesked
          </Button>
        )}
        <Button onClick={onClose} color="inherit">
          Avbryt
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionConfirmDialog;